export default function OfficeSpace(client,tid,id,name,isPrivate){return {'client': client, 'tid': tid, 'id': id, 'name': name, 'isPrivate': isPrivate}}